import React, {FC, useEffect, useCallback} from 'react'
import RamblerTopline from '@rambler-components/topline'
import '@rambler-components/topline/styles.css'
import styles from './styles.css'

const advertElement = <div id="block_pad_id_549396273_547613547" />

interface Props {
  onOpenGeo: () => void
}

export const DesktopTopline: FC<Props> = ({onOpenGeo}) => {
  const loadBanner = useCallback(() => {
    window.Adf.banner.ssp(
      'block_pad_id_549396273_547613547',
      {},
      {'begun-auto-pad': '547613547', 'begun-block-id': '549396273'}
    )
  }, [])

  useEffect(() => {
    if (window.Adf) {
      loadBanner()

      return
    }

    window.begun_callbacks = {
      lib: {
        init: loadBanner
      }
    }
  }, [loadBanner])

  return (
    <div className={styles.desktop}>
      <RamblerTopline
        projectCode="id"
        promoAd={advertElement}
        simpleView
        onOpenGeo={onOpenGeo}
      />
    </div>
  )
}

export default DesktopTopline
